import React from 'react';

const Error = () => (
  <div>
    <h1>This is an Error Page !</h1>
  </div>
);

export default Error;
